import { render } from "./calendarCertifications.vue?vue&type=template&id=272ca420&scoped=true&ts=true"
import script from "./calendarCertifications.vue?vue&type=script&lang=ts"
export * from "./calendarCertifications.vue?vue&type=script&lang=ts"

import "./calendarCertifications.vue?vue&type=style&index=0&id=272ca420&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-272ca420"]])

export default __exports__